import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/components/NotAuthorizedComponent.js
import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const NotAuthorizedComponent = () => {
    const navigate = useNavigate();
    return (_jsxs(Container, { children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: "You are not authorized to view this page." }), _jsx(Button, { variant: "contained", onClick: () => navigate('/'), children: "Go to Home" })] }));
};
export default NotAuthorizedComponent;
